import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled React error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Box sx={{ minHeight: '100vh', p: 3, display: 'grid', placeItems: 'center', backgroundColor: '#f9fafb' }}>
        <Box sx={{ width: '100%', maxWidth: 760, bgcolor: 'background.paper', borderRadius: 2, p: 3, boxShadow: 2 }}>
          <Stack spacing={2}>
            <Typography variant="h5" fontWeight={700}>Something went wrong</Typography>
            <Typography color="text.secondary">
              The page encountered an unexpected error and was stopped to prevent a blank screen.
            </Typography>
            <Alert severity="error">
              {this.state.error?.message || 'Unexpected runtime error.'}
            </Alert>
            <Box>
              <Button variant="contained" onClick={this.handleReload}>Reload Portal</Button>
            </Box>
          </Stack>
        </Box>
      </Box>
    );
  }
}

export default ErrorBoundary;
